import { Text, View } from "@react-pdf/renderer";

import { usePdfChromeScale } from "../pdf-page-chrome";
import TextWrapper from "./text-wrapper.component";

type PdfDocumentLabelValueProps = {
  label?: string;
  // Used as given; the defaults are scaled on a Form's page (ENG-2277, see pdf-page-chrome).
  labelWidth?: string;
  valueMaxWidth?: string;
  value: any;
  noBorder?: boolean;
  compact?: boolean;
  style?: any;
};
export default function PdfDocumentLabelValue({
  label,
  labelWidth,
  valueMaxWidth,
  value,
  noBorder,
  compact = false,
  style = {}
}: PdfDocumentLabelValueProps) {
  const { px } = usePdfChromeScale();
  return (
    <View
      style={{
        borderBottom: noBorder ? undefined : `${px(1)} solid #381337`,
        paddingTop: px(compact ? 1 : 4),
        paddingBottom: px(compact ? 1 : 4),
        color: "#000000",
        ...style
      }}
    >
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          gap: px(8),
          minHeight: px(compact ? 12 : 16),
          color: "#000000"
        }}
      >
        {Boolean(label) && (
          <View
            style={{
              width: labelWidth ?? px(65),
              paddingTop: px(2),
              color: "#000000"
            }}
          >
            <Text style={{ fontSize: px(11), color: "#000000" }}>{label}</Text>
          </View>
        )}

        <View style={{ maxWidth: valueMaxWidth ?? px(280) }}>
          {typeof value === "string" || !Boolean(value) ? (
            <TextWrapper
              text={String(value ?? "")}
              style={{ fontSize: px(14), color: "#000000" }}
            />
          ) : (
            value
          )}
        </View>
      </View>
    </View>
  );
}
